// src/components/SortableItem.jsx

import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableItem = ({ id, option, mapping, isShowColors }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id: id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
        width: '100%',
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`draggable-item ${isShowColors ? mapping.toLowerCase().replace('_', '-') : ''}`}
            {...attributes}
            {...listeners}
            aria-label={`Option: ${option}`}
        >
            <span className="draggable-item__text">{option}</span>
        </div>
    );
};

export default SortableItem;
